import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ContactForm from './contact-form';
import { BaseTitle } from './styles';

const Container = styled.div`
  position: relative;
  padding-top: ${props => (props.theme.isMobile ? '32px' : '80px')};
  padding-bottom: ${props => (props.theme.isMobile ? '32px' : '80px')};
  padding-left: ${props => (props.theme.isMobile ? '20px' : '')};
  padding-right: ${props => (props.theme.isMobile ? '20px' : '')};
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${props => (props.theme.isMobile ? `
    background-image: url(${props.theme.linearGradientMobileImage});
    background-size: cover;
    background-position: center;
  ` : `
    background: linear-gradient(-100.09deg, rgba(253, 255, 255, 0.5) 47.62%, rgba(255, 255, 255, 0.5) 54.33%, rgba(144, 237, 255, 0.5) 122.74%), linear-gradient(100.09deg, rgba(253, 255, 255, 0.5) 47.62%, rgba(255, 255, 255, 0.5) 54.33%, rgba(144, 237, 255, 0.5) 122.74%);
  `)};
`;

const Title = styled(BaseTitle)`
  max-width: 100%;
`;

const FormContainer = styled.div`
  width: 100%;
  max-width: 530px;
  textarea::placeholder,
  input::placeholder {
    text-transform: uppercase;
    font-family: ${props => props.theme.fontFamilyBody};
    font-weight: ${props => props.theme.fontWeightBold};
  }

  button {
    width: 100%;
    margin-top: 20px;
  }
`;

export default function Contact(props) {
  const { formId, formName, formTitle } = props;

  return (
    <Container id={formId} name={formName}>
      <Title>{formTitle}</Title>
      <FormContainer>
        <ContactForm />
      </FormContainer>
    </Container>
  );
}

Contact.propTypes = {
  formId: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  formTitle: PropTypes.string.isRequired,
};
